import { Dialog } from "@appretio/ui-kit";
import type { ReactNode } from "react";

/** Props for the confirmation dialog shown before executing a cube operation. */
interface ConfirmOperationDialogProps {
  /** Whether the dialog is currently open. */
  open: boolean;
  /** Callback to toggle the dialog open state. */
  onOpenChange: (open: boolean) => void;
  /** Dialog title displayed in the header. */
  title: string;
  /** Content describing the operation to confirm. */
  children: ReactNode;
  /** Callback invoked when the user confirms the operation. */
  onConfirm: () => void;
  /** Whether the operation is in progress (disables confirm button). */
  isLoading?: boolean;
  /** Label for the confirm button. Defaults to "Confirm". */
  confirmText?: string;
}

export function ConfirmOperationDialog({
  open,
  onOpenChange,
  title,
  children,
  onConfirm,
  isLoading = false,
  confirmText = "Confirm"
}: ConfirmOperationDialogProps) {
  return (
    <Dialog
      hideFeedbackIcon
      open={open}
      onOpenChange={onOpenChange}
      title={title}
      confirmText={confirmText}
      cancelText="Cancel"
      onConfirm={() => {
        onConfirm();
        return false;
      }}
      isLoading={isLoading}
    >
      {children}
    </Dialog>
  );
}
